import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import compact from 'lodash/compact';
import flatten from 'lodash/flatten';
import uniq from 'lodash/uniq';
import { DropdownButton, OverlayTrigger, Tooltip } from 'react-bootstrap';

import Button from 'shared/button';
import CreateModal from './modal';
import ListingTypes from './listing_types';
import { buildNewDeal } from './helpers';

export default function DealCreationButton({
  condoListings,
  leaseSpaceListings,
  lotListings,
  path,
  saleListing,
  onNewDeal
}) {
  const [selectedListings, setSelectedListings] = useState();

  const allListings = useMemo(() => compact(flatten([condoListings, leaseSpaceListings, lotListings, saleListing])));
  const listingTypeCount = useMemo(() => uniq(allListings.map(listing => listing.type)).length);

  let button;
  if (listingTypeCount === 0) {
    const tooltip = (
      <Tooltip id="disabled-for-project">
        To create a deal, your listing must be marked as "For Sale" or "For Lease."
      </Tooltip>
    );

    button = (
      <OverlayTrigger overlay={tooltip} placement="bottom">
        <div>
          <Button.Primary className="disabled">
            Create Deal
          </Button.Primary>
        </div>
      </OverlayTrigger>
    );
  } else if (listingTypeCount === 1) {
    const handleClick = async () => {
      if (allListings.length === 1) {
        const listing = allListings[0];
        const deal = await buildNewDeal(path, listing);
        onNewDeal(deal, listing);
      } else {
        setSelectedListings(allListings);
      }
    };

    button = (
      <Button.Primary onClick={handleClick}>
        Create Deal
      </Button.Primary>
    );
  } else {
    const handleSelect = async (selection) => {
      if (selection.length === 1) {
        const listing = selection[0];
        const deal = await buildNewDeal(path, listing);
        onNewDeal(deal, listing);
      } else {
        setSelectedListings(selection);
      }
    };

    button = (
      <DropdownButton
        bsStyle="create"
        id="create-deal-dropdown-button"
        pullRight
        title="Create Deal"
      >
        <ListingTypes
          condoListings={condoListings}
          leaseSpaceListings={leaseSpaceListings}
          lotListings={lotListings}
          saleListing={saleListing}
          onListingsSelect={handleSelect}
        />
      </DropdownButton>
    );
  }

  return <React.Fragment>
    {button}
    <CreateModal
      listings={selectedListings}
      path={path}
      show={selectedListings != null}
      onHide={() => setSelectedListings(null)}
      onNewDeal={onNewDeal}
    />
  </React.Fragment>;
}

DealCreationButton.propTypes = {
  condoListings: PropTypes.array,
  leaseSpaceListings: PropTypes.array,
  lotListings: PropTypes.array,
  path: PropTypes.string.isRequired,
  saleListing: PropTypes.object,
  onNewDeal: PropTypes.func.isRequired,
};
